module.exports = __webpack_public_path__ + "img/ic-members.8e425bef.svg";